import Stack from '@mui/material/Stack/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography/Typography'

import { i18WithParams as t } from '@shared/locale'
import { ServiceTypeAvatar } from 'components-ui/src/icon_avatar/icon_avatar'

interface Props {
  serviceTypes: string[]
}

export const InStayServiceTypes = ({ serviceTypes }: Props) => {
  const theme = useTheme()

  if (serviceTypes.length === 0) return null

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ marginLeft: '4px !important', marginTop: '0 !important' }}
    >
      <Typography variant="body2">{t('global.label.with')}</Typography>

      {serviceTypes.map((serviceType) => (
        <ServiceTypeAvatar
          key={serviceType}
          serviceType={serviceType}
          fontSize="small"
          size="small"
          backgroundColor="transparent"
          fillColor={theme.palette.action.active}
          sx={{ marginLeft: '0 !important' }}
        />
      ))}
    </Stack>
  )
}
